module.exports = __webpack_public_path__ + "static/yulia_0-7d785b872cca19e101f65dfe2f0e22de.jpg";